<div class="yearly-upgrade-container">
  <div class="yearly-upgrade-content">
    <div class="yearly-upgrade-icon">
      💡
    </div>
    <h2 class="yearly-upgrade-title">¡Ahorra con tiempo bonificado!</h2>
    <p class="yearly-upgrade-subtitle">Accederás sin compromiso. Puedes cambiar tu plan cuando lo desees.</p>

    <div class="yearly-upgrade-benefits">
      <div class="benefit-item">
        <div class="benefit-icon">💰</div>
        <div class="benefit-text">
          <strong>Ahorra significativamente</strong>
          <p>Paga 11 meses y obtén 12 meses de servicio</p>
        </div>
      </div>
      <div class="benefit-item">
        <div class="benefit-icon">🎁</div>
        <div class="benefit-text">
          <strong>1 mes GRATIS como bonus</strong>
          <p>Equivalente a 1 mes de ahorro al año</p>
        </div>
      </div>
      <div class="benefit-item">
        <div class="benefit-icon">📅</div>
        <div class="benefit-text">
          <strong>Ciclo de renovación fijo</strong>
          <p>Gestiona tu suscripción con mayor facilidad</p>
        </div>
      </div>
    </div>

    <div class="plan-change-box" *ngIf="hasPreview">
      <convfact-plan-change-preview
        [planAlias]="data.planAlias"
        [period]="data.period"
        [renewalAmount]="data.renewalAmount"
        (stateChange)="onPreviewState($event)">
      </convfact-plan-change-preview>
    </div>

    <div class="yearly-upgrade-actions">
      <button type="button" class="btn btn-primary" (click)="onAccept()" [disabled]="preview.loading">
        ✅ Cambiar a Plan Anual
      </button>
      <button type="button" class="btn btn-secondary" (click)="onCancel()">
        No por ahora
      </button>
    </div>
  </div>
</div>
